module.exports = __webpack_public_path__ + "static/media/Section-1-2.63b83ee9.mp3";